export function isValidProviderResult(res) {

  return res.ok && !!res.data;
}

export function isValidEmail(email) {

  if (typeof email !== 'string') {
    return false;
  }

  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
}

export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) return phoneNumber;
  
  phoneNumber = String(phoneNumber);
  
  // Remove any whitespace
  phoneNumber = phoneNumber.replace(/\s+/g, '');
  
  // If the phone number starts with '0', replace it with '+27'
  if (phoneNumber.startsWith('0')) {
    return '+27' + phoneNumber.substring(1);
  }
  
  // If it doesn't start with '+', add it
  if (!phoneNumber.startsWith('+')) {
    return '+' + phoneNumber;
  }
  
  return phoneNumber;
};

export function formatPhoneNumberDisplay(phoneNumber) {
  if (!phoneNumber) return phoneNumber;
  
  phoneNumber = String(phoneNumber);
  
  // Replace +27 with 0
  phoneNumber = phoneNumber.replace('+27', '0');
  
  // Strip out all non-digit characters
  phoneNumber = phoneNumber.replace(/\D/g, '');
  
  const length = phoneNumber.length;

  // If length <= 3, return as is
  if (length <= 3) {
    return phoneNumber;
  }
  
  // When length > 3 and <= 6: format as "XXX Y" (e.g., "082 4", "082 43", "082 437")
  if (length > 3 && length <= 6) {
    const firstThree = phoneNumber.substring(0, 3);
    const remaining = phoneNumber.substring(3);
    return `${firstThree} ${remaining}`;
  }
  
  // When length > 6: format as "XXX XXX Y" (e.g., "082 437 4", "082 437 44", etc.)
  const firstThree = phoneNumber.substring(0, 3);
  const nextThree = phoneNumber.substring(3, 6);
  const remaining = phoneNumber.substring(6, 10); // Max 4 digits (positions 6-9)
  
  return `${firstThree} ${nextThree} ${remaining}`;
};

export function isValidPhoneNumber(phone) {

  if (!phone) {
    return false;
  }

  phone = formatPhoneNumber(phone);

  return phone.startsWith('+27') && phone.length === 12;
}